import { render, staticRenderFns } from "./LandingPageCostsaver.vue?vue&type=template&id=cb38feec&scoped=true&"
import script from "./LandingPageCostsaver.vue?vue&type=script&lang=js&"
export * from "./LandingPageCostsaver.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageCostsaver.vue?vue&type=style&index=0&id=cb38feec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb38feec",
  null
  
)

export default component.exports